module.exports = __webpack_public_path__ + "img/21.519339ac.png";